import { createSelector } from 'reselect'
import get from 'lodash/get'
import appConstants from '../../../../custom/config/appConstants'
import uuid from 'react-uuid'
import { formatAmount, formatData, formatDataShort, formatMonthYear } from '../../common/selectors'

export const getPaymentState = createSelector(
    [
        (state) => {
            return get(state, appConstants.store.routes.payments)
        },
    ],
    (state) => state,
)

export const getPaymentIsFetching = createSelector([getPaymentState], (state) => {
    try {
        return state.isFetching
    } catch (e) {
    }
    return false

})

export const getPayments = createSelector([getPaymentState, (state, paymentKey) => paymentKey], (state, paymentKey) => {
    try {
        return state[paymentKey]
    } catch (e) {
    }

    return null
})

export const getPaymentsPage = createSelector([getPayments], (state) => {
    try {
        return state.page ? state.page : null
    } catch (e) {
    }

    return null
})
export const getPaymentsSearch = createSelector([getPayments], (state) => {
    try {
        return state.search ? state.search : null
    } catch (e) {
    }

    return null
})

export const getPaymentsEmployerMOLId = createSelector([getPayments], (state) => {
    try {
        return state.employerMOLId ? state.employerMOLId : null
    } catch (e) {
    }

    return null
})

export const getPaymentsDateRange = createSelector([getPayments], (state) => {
    try {
        return state.dateRange ? state.dateRange : null
    } catch (e) {
    }

    return null
})

export const getPaymentsMonth = createSelector([getPayments], (state) => {
    try {
        return state.month != null ? state.month : null
    } catch (e) {
    }

    return null
})

export const getPaymentsNumOfPages = createSelector([getPayments], (state) => {
    try {
        return state.numOfPages ? state.numOfPages : 1
    } catch (e) {
    }

    return 1
})
export const getPaymentsTransactions = createSelector([getPayments], (state) => {

    try {
        return state.transactions ? state.transactions : []
    } catch (e) {
      return []
    }
    return []
})

export const getAuthBulkPaymentTransactionsF = createSelector([getPaymentsTransactions], (transactions) => {
    try {
        if (transactions) {
            return transactions.map((item) => {
                return {
                    ...item,
                    paymentId: item._id.toUpperCase(),
                    download: '',
                    approve: '',
                    reject: '',
                    rowId: uuid(),

                    amount: formatAmount(item.amount),
                    userFileName: item.userFileName || 'N/A',
                    uploadedAt: formatData(item.uploadedAt) || 'N/A',
                    statusUpdatedAt: formatData(item.statusUpdatedAt) || 'N/A',
                    scheduledFor: formatData(item.scheduledFor) || 'N/A',
                    status: item.authorizationTableStatus || item.status || 'N/A',
                    isAuthorizationScheduled: item.isAuthorizationScheduled || false,
                }
            })
        }
        return []
    } catch (e) {
    }
    return []
})

export const getAuthIndividualPaymentTransactionsF = createSelector([getPaymentsTransactions], (transactions) => {
    try {
        if (transactions) {
            return transactions.map((item) => {
                return {
                    ...item,
                    individualSalaryFileEid: item.individualSalaryFileEid || 'N/A',
                    download: '',
                    approve: '',
                    reject: '',
                    rowId: uuid(),
                    fileType: item.fileType || 'N/A',
                    amount: formatAmount(item.amount),
                    userFileName: item.userFileName || 'N/A',
                    uploadedAt: formatData(item.uploadedAt) || 'N/A',
                    statusUpdatedAt: formatData(item.statusUpdatedAt) || 'N/A',
                    scheduledFor: formatData(item.scheduledFor) || 'N/A',
                    status: item.authorizationTableStatus || item.status || 'N/A',
                    isAuthorizationScheduled: item.isAuthorizationScheduled || false,
                }
            })
        }
        return []
    } catch (e) {
    }
    return []
})

export const getAuthWpsPaymentTransactionsF = createSelector([getPaymentsTransactions], (transactions) => {
    try {
        if (transactions) {
            return transactions.map((item) => {
                // Format scheduledFor as "Month, YYYY" using salaryMonth if available
                let scheduledForFormatted = 'N/A'
                if (item.salaryMonth) {
                    try {
                        const month = parseInt(item.salaryMonth.slice(0, 2), 10)
                        const year = parseInt(item.salaryMonth.slice(2, 6), 10)
                        const date = new Date(year, month - 1) // month is 0-indexed in Date
                        scheduledForFormatted = date.toLocaleDateString('en-US', { month: 'long', year: 'numeric' })
                    } catch (e) {
                        scheduledForFormatted = formatData(item.scheduledFor) || 'N/A'
                    }
                } else {
                    scheduledForFormatted = formatData(item.scheduledFor) || 'N/A'
                }

                return {
                    ...item,
                    paymentId: item._id.toUpperCase(),
                    download: '',
                    approve: '',
                    reject: '',
                    rowId: uuid(),

                    amount: formatAmount(item.amount),
                    userFileName: item.userFileName || 'N/A',
                    uploadedAt: formatData(item.uploadedAt) || 'N/A',
                    statusUpdatedAt: formatData(item.statusUpdatedAt) || 'N/A',
                    scheduledFor: scheduledForFormatted,
                    status: item.authorizationTableStatus || item.status || 'N/A',
                    isAuthorizationScheduled: item.isAuthorizationScheduled || false,
                }
            })
        }
        return []
    } catch (e) {
    }
    return []
})

export const getAuthAllPaymentTransactionsF = createSelector([getPaymentsTransactions], (transactions) => {
    try {
        if (transactions) {
            return transactions.map((item) => {
                // Format scheduledFor (handle WPS salaryMonth format)
                let scheduledForFormatted = 'N/A'
                if (item.salaryMonth) {
                    try {
                        const month = parseInt(item.salaryMonth.slice(0, 2), 10)
                        const year = parseInt(item.salaryMonth.slice(2, 6), 10)
                        const date = new Date(year, month - 1)
                        scheduledForFormatted = date.toLocaleDateString('en-US', { month: 'long', year: 'numeric' })
                    } catch (e) {
                        scheduledForFormatted = formatData(item.scheduledFor) || 'N/A'
                    }
                } else {
                    scheduledForFormatted = formatData(item.scheduledFor) || 'N/A'
                }

                return {
                    ...item,
                    paymentId: item._id ? item._id.toUpperCase() : 'N/A',
                    paymentType: item.paymentType || 'N/A',
                    paymentTypeLabel: item.paymentTypeLabel || 'N/A',
                    individualSalaryFileEid: item.individualSalaryFileEid || '-',
                    fileSubType: item.fileSubType || '-',
                    description: item.description || '-',
                    download: '',
                    approve: '',
                    reject: '',
                    rowId: uuid(),
                    amount: formatAmount(item.amount),
                    userFileName: item.userFileName || 'N/A',
                    uploadedAt: formatData(item.uploadedAt) || 'N/A',
                    statusUpdatedAt: formatData(item.statusUpdatedAt) || 'N/A',
                    scheduledFor: scheduledForFormatted,
                    status: item.authorizationTableStatus || item.status || 'N/A',
                    isAuthorizationScheduled: item.isAuthorizationScheduled || false,
                }
            })
        }
        return []
    } catch (e) {
    }
    return []
})

export const getValidateAllPaymentTransactionsF = createSelector([getPaymentsTransactions], (transactions) => {
    try {
        if (transactions) {
            return transactions.map((item) => {
                // Format scheduledFor (handle WPS salaryMonth format)
                let scheduledForFormatted = 'N/A'
                if (item.salaryMonth) {
                    try {
                        const month = parseInt(item.salaryMonth.slice(0, 2), 10)
                        const year = parseInt(item.salaryMonth.slice(2, 6), 10)
                        const date = new Date(year, month - 1)
                        scheduledForFormatted = date.toLocaleDateString('en-US', { month: 'long', year: 'numeric' })
                    } catch (e) {
                        scheduledForFormatted = formatData(item.scheduledFor) || 'N/A'
                    }
                } else {
                    scheduledForFormatted = formatData(item.scheduledFor) || 'N/A'
                }

                return {
                    ...item,
                    paymentId: item._id ? item._id.toUpperCase() : 'N/A',
                    paymentType: item.paymentType || 'N/A',
                    paymentTypeLabel: item.paymentTypeLabel || 'N/A',
                    individualSalaryFileEid: item.individualSalaryFileEid || '-',
                    fileSubType: item.fileSubType || '-',
                    description: item.description || '-',
                    download: '',
                    approve: '',
                    reject: '',
                    rowId: uuid(),
                    amount: formatAmount(item.amount),
                    userFileName: item.userFileName || 'N/A',
                    uploadedAt: formatData(item.uploadedAt) || 'N/A',
                    statusUpdatedAt: formatData(item.statusUpdatedAt) || 'N/A',
                    scheduledFor: scheduledForFormatted,
                    status: item.status || 'N/A',
                }
            })
        }
        return []
    } catch (e) {
    }
    return []
})


export const getValidateBulkPaymentTransactionsF = createSelector([getPaymentsTransactions], (transactions) => {
    try {
        if (transactions) {
            return transactions.map((item) => {
                return {
                    ...item,
                    paymentId: item._id.toUpperCase(),
                    download: '',
                    approve: '',
                    reject: '',
                    rowId: uuid(),
                    amount: formatAmount(item.amount),
                    userFileName: item.userFileName || 'N/A',
                    uploadedAt: formatData(item.uploadedAt) || 'N/A',
                    statusUpdatedAt: formatData(item.statusUpdatedAt) || 'N/A',
                    scheduledFor: formatData(item.scheduledFor) || 'N/A',
                    status: item.status || 'N/A',
                }
            })
        }
        return []
    } catch (e) {
    }
    return []
})

export const getValidateIndividualPaymentTransactionsF = createSelector([getPaymentsTransactions], (transactions) => {
    try {
        if (transactions) {
            return transactions.map((item) => {
                return {
                    ...item,
                    individualSalaryFileEid: item.individualSalaryFileEid || 'N/A',
                    download: '',
                    approve: '',
                    reject: '',
                    rowId: uuid(),
                    fileType: item.fileType || 'N/A',
                    amount: formatAmount(item.amount),
                    userFileName: item.userFileName || 'N/A',
                    uploadedAt: formatData(item.uploadedAt) || 'N/A',
                    statusUpdatedAt: formatData(item.statusUpdatedAt) || 'N/A',
                    scheduledFor: formatData(item.scheduledFor) || 'N/A',
                    status: item.status || 'N/A',
                }
            })
        }
        return []
    } catch (e) {
    }
    return []
})

export const getValidateWpsPaymentTransactionsF = createSelector([getPaymentsTransactions], (transactions) => {
    try {
        if (transactions) {
            return transactions.map((item) => {
                // Format scheduledFor as "Month, YYYY" using salaryMonth if available
                let scheduledForFormatted = 'N/A'
                if (item.salaryMonth) {
                    try {
                        const month = parseInt(item.salaryMonth.slice(0, 2), 10)
                        const year = parseInt(item.salaryMonth.slice(2, 6), 10)
                        const date = new Date(year, month - 1) // month is 0-indexed in Date
                        scheduledForFormatted = date.toLocaleDateString('en-US', { month: 'long', year: 'numeric' })
                    } catch (e) {
                        scheduledForFormatted = formatData(item.scheduledFor) || 'N/A'
                    }
                } else {
                    scheduledForFormatted = formatData(item.scheduledFor) || 'N/A'
                }

                return {
                    ...item,
                    paymentId: item._id.toUpperCase(),
                    download: '',
                    approve: '',
                    reject: '',
                    rowId: uuid(),

                    amount: formatAmount(item.amount),
                    userFileName: item.userFileName || 'N/A',
                    uploadedAt: formatData(item.uploadedAt) || 'N/A',
                    statusUpdatedAt: formatData(item.statusUpdatedAt) || 'N/A',
                    scheduledFor: scheduledForFormatted,
                    status: item.status || 'N/A',
                }
            })
        }
        return []
    } catch (e) {
    }
    return []
})

export const getWpsStatusTransactionsF = createSelector([getPaymentsTransactions], (transactions) => {
    try {
        if (transactions) {
            return transactions.map((item) => {
                return {
                    ...item,
                    actions: '',
                    rowId: uuid(),
                    paymentId: item._id || 'N/A',
                    amount: formatAmount(item.amount),
                    fees: item.fees || 'N/A',
                    status: item.status || 'N/A',
                    validationFailureReason: item.validationFailureReason || '',
                    numOfRefunded: item.numOfRefunded || 0,
                    statusUpdatedAt: formatData(item.statusUpdatedAt),
                    uploadedAt: formatData(item.uploadedAt),
                }
            })
        }
        return []
    } catch (e) {
    }
    return []
})
export const getNonWpsStatusTransactionsF = createSelector([getPaymentsTransactions], (transactions) => {
    try {
        if (transactions) {
          console.log(transactions)
            return transactions.map((item) => {
                return {
                    ...item,
                    actions: '',
                    rowId: uuid(),
                    paymentId: item._id || 'N/A',
                    amount: formatAmount(item.amount),
                    fees: item.fees || 'N/A',
                    status: item.status || 'N/A',
                    statusUpdatedAt: formatData(item.statusUpdatedAt),
                    uploadedAt: formatData(item.uploadedAt),
                }
            })
        }
    } catch (e) {
      console.log(e)
    }
    return []
})



export const getStatusReportTransactionsF = createSelector([getPaymentsTransactions], (transactions) => {
    try {
        if (transactions) {
            return transactions.map((item) => {
                return {
                    ...item,
                    file: '',
                    rowId: uuid(),
                    transactionType: item.transactionType || 'N/A',
                    amount: formatAmount(item.amount),
                    fees: item.fees || 'N/A',
                    userFileName: item.userFileName || 'N/A',
                    uploadedAt: formatData(item.uploadedAt) || 'N/A',
                    statusUpdatedAt: formatData(item.statusUpdatedAt) || 'N/A',
                    lastActionBy: item.lastActionBy || 'N/A',
                    status: item.status || 'N/A',
                }
            })
        }
        return []
    } catch (e) {
    }
    return []
})

export const getViewPaymentsTransactionsF = createSelector([getPaymentsTransactions], (transactions) => {
    try {
        if (transactions) {
            return transactions.map((item) => {
              return {
                ...item,
                actions: '',
                rowId: uuid(),
                employeeId: item.employeeId || '-',
                employeeName: item.employeeName || '-',
                employeeMOLId: item?.wpsInternalFields?.molId || '-',
                employerMOLId: item?.wpsInternalFields?.employerLRAId || '-',
                iban: item.iban,
                paymentType: item.paymentType || '-',
                fileName: item.salaryFileName || '-',
                paidAt: formatDataShort({ createdAt: item.paidAt }) || '-',
                salaryMonthOrDescription: item.paymentType === "WPS SALARY" ? formatMonthYear(item.salaryMonth) : item.description,
                amount: item.salary || '-',
                status: item.paid === true ? 'Received' : (item.registered === true) ? 'Could not Load Funds' : 'Account not active/connected',
              }
            })
        }
        return []
    } catch (e) {
    }
    return []
})

export const getTransactionsBalance = createSelector([getPaymentState], (state) => {
    try {
        return formatAmount(state.balance ? state.balance : '0.00', true)
    } catch (e) {
    }
    return '0'

})

export const getPaymentSearch = createSelector([getPaymentState], (state) => {
    try {
        return state.ViewPayments.search
    } catch (e) {
    }
    return null

})

export const getPaymentEmployerMOLId = createSelector([getPaymentState], (state) => {
    try {
        return state.ViewPayments.employerMOLId
    } catch (e) {
    }
    return null

})
